

















































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from "vuex-class";
import API from '@/Api';
const namespace: string = "AppStore";
import { ICodeTable , ISclModel, ISnackBar } from '@/models/Common';
import { constants } from 'http2';

@Component
export default class PerformanceAppraisal extends Vue {
  @Getter("role", { namespace }) public role: any;
  @Getter("name", { namespace }) public userName: any;

  public selfSubmit: boolean = false;
  public managerSubmit: boolean = false;
  public reviewerSubmit: boolean = false;

  public loader: boolean = false;

  public quartercycle: string = '';
  public qyear: string = '';

  public headers: any[] = [
    {
      text: 'EmpName & Self ratings',
      align: 'left',
      sortable: false,
      value: 'quarter',
    },
    // {
    //   text: 'Q1',
    //   align: 'left',
    //   sortable: false,
    //   value: 'status',
    // },
    // {
    //   text: 'Q2',
    //   align: 'center',
    //   sortable: false,
    //   value: 'manage',
    // },
    // {
    //   text: 'Q3',
    //   align: 'center',
    //   sortable: false,
    //   value: 'manage',
    // },
    // {
    //   text: 'Q4',
    //   align: 'center',
    //   sortable: false,
    //   value: 'manage',
    // },
    {
      text: 'KRA self(Overall)',
      align: 'left',
      sortable: false,
      value: 'KRA',
    },
    {
      text: 'KRA Manager(Overall)',
      align: 'left',
      sortable: false,
      value: 'KRA',
    },
    {
      text: 'WOW (Overall)',
      align: 'left',
      sortable: false,
      value: 'WOW',
    },
    
    {
      text: 'Final Rating',
      align: 'left',
      sortable: false,
      value: 'Final',
    },
    {
      text: 'Reviewer Rating',
      align: 'left',
      sortable: false,
      value: 'Final',
    },
    
    
    
  ];
  public id: any = null;
  public eid: any = null;
  public items: any[] = [];
  public item: any = null;
  public title: string = '';
  public hasCodeTableLoaded: boolean = false;
  public dataTable: ISclModel[] = [];
  public incrementCycle: string = '';
  public cellBorders: any[] = [
    'cell-border-1',
    'cell-border-2',
    'cell-border-3',
    'cell-border-4',
    'cell-border-5',
  ];
  public list1: any = [];
  public list2: any = [];
  public list3: any = [];

  
  public created() {
    // API.Instance.get('/api/code-table?id=14&seletedId=').then((response) => {
    //   this.hasCodeTableLoaded = true;
    //   this.loadData();
    // });
    this.loadData();
  }

  public mounted() {
   
      this.loadData();
   
  }

  public loadData() {

    API.Instance.get('/api/goalsettings/reviewassesment').then((respone) => {
      this.dataTable = respone.data;
      this.items = respone.data;
      
    });

  //   API.Instance.get('api/goalsettings/getempquarterbyhr?eid='+this.eid).then((response) => {     
    
  //   this.items = response.data;
    
  // });

  }
 
  public downloadReport() {
    this.loader = true;
    API.Instance
      .get('/api/goalsettings/report')
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'OKR_Goal_Setting_Report.csv';
        link.click();
        this.loader = false;
      });
  }

  public refreshpage() {
    
    // this.$router.go(0) ;
    window.location.reload(true);
}

  
}


